import React, { useState, useEffect } from 'react';
import './Estado_edicion.css';

const EstadoEdicion = () => {
  const [tickets, setTickets] = useState([]);
  const [ticketSeleccionado, setTicketSeleccionado] = useState('');
  const [datosPublicacion, setDatosPublicacion] = useState({
    ticket: '',
    fechaIngreso: '',
    fechaResolucion: '',
    estado: '',
    diasRestantes: ''
  });
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  // URL del microservicio estado_publicaciones
const estadoUrl = process.env.REACT_APP_ESTADO_EDICION_URL
  || 'http://45.7.228.150:63/estado_edicion';

  useEffect(() => {
    cargarTickets();
  }, []);

  // ============================================
  // CARGAR TICKETS DEL USUARIO AUTENTICADO
  // Llama a get_tickets.php con la sesión activa
  // ============================================
  const cargarTickets = async () => {
    try {
      setLoading(true);
      setErrorMsg('');

      const response = await fetch(`${estadoUrl}/get_tickets.php`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        // Si no está autenticado redirigir al login
        if (response.status === 401) {
          setErrorMsg('Sesión expirada. Por favor inicia sesión nuevamente.');
          setLoading(false);
          return;
        }
        throw new Error(data.message || 'Error al cargar tickets');
      }

      setTickets(data.data || []);
      setLoading(false);

    } catch (error) {
      console.error('Error al cargar tickets:', error);
      setErrorMsg('Error al cargar los tickets. Intenta recargar la página.');
      setLoading(false);
    }
  };

  // ============================================
  // BUSCAR DETALLE DEL TICKET SELECCIONADO
  // Busca en el array ya cargado (sin nueva llamada)
  // ============================================
const buscarPublicacion = async () => {
  if (!ticketSeleccionado) {
    alert('Por favor selecciona un ticket');
    return;
  }

  // ============================================
  // LLAMAR AL BACKEND para obtener datos frescos
  // Así el contador se actualiza en cada búsqueda
  // ============================================
  try {
    setLoading(true);
    setErrorMsg('');

    const response = await fetch(`${estadoUrl}/get_tickets.php`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      if (response.status === 401) {
        setErrorMsg('Sesión expirada. Por favor inicia sesión nuevamente.');
        setLoading(false);
        return;
      }
      throw new Error(data.message || 'Error al consultar tickets');
    }

    // Actualizar lista completa de tickets
    const ticketsActualizados = data.data || [];
    setTickets(ticketsActualizados);

    // Buscar el ticket seleccionado en los datos frescos
    const ticketEncontrado = ticketsActualizados.find(
      (t) => t.ticket === ticketSeleccionado
    );

    if (!ticketEncontrado) {
      alert('Ticket no encontrado');
      setLoading(false);
      return;
    }

    setDatosPublicacion({
      ticket:          ticketEncontrado.ticket,
      fechaIngreso:    ticketEncontrado.fecha_ingreso,
      fechaResolucion: ticketEncontrado.fecha_resolucion,
      estado:          ticketEncontrado.estado,
      diasRestantes:   ticketEncontrado.proceso_finalizacion
    });

    setLoading(false);

  } catch (error) {
    console.error('Error al buscar ticket:', error);
    setErrorMsg('Error al consultar el estado. Intenta de nuevo.');
    setLoading(false);
  }
};

  // ============================================
  // COLOR DEL ESTADO para resaltar visualmente
  // ============================================
  const getColorEstado = (estado) => {
    switch (estado) {
      case 'Aprobada':  return '#008000';
      case 'Rechazada': return '#FF0000';
      case 'Pendiente': return '#FFA500';
      default:          return '#000000';
    }
  };

return (
    <>
      <div className="estado-publicaciones-container">
      <div className="estado-publicaciones-content">
        <h1 className="estado-titulo">ESTADO DE TUS FOTOS - VIDEOS Y AUDIO</h1>
        <hr className="estado-linea" />
        
<div className="estado-texto-info">
          <p className="texto-normal">
            Puedes verificar mediante el N° de ticket el estado de tus modificaciones de fotos, videos o audio.
          </p>
          
          <p className="texto-normal">
            <span className="texto-rojo"><strong>NOTA IMPORTANTE :</strong></span> Una vez el estado del ticket cambie a <span className="texto-rojo"><strong>APROBADO</strong></span>, automaticamente se realizara el cambio, recuerda que estos tres procesos necesitan revision.
          </p>
        </div>

        {/* Mensaje de error de conexión */}
        {errorMsg && (
          <div style={{
            backgroundColor: '#fff3cd',
            border: '2px solid #FF0000',
            padding: '10px 15px',
            marginBottom: '20px',
            fontFamily: "'Arial Black', Arial, sans-serif",
            fontSize: '14px',
            color: '#FF0000',
            fontWeight: 'bold'
          }}>
            {errorMsg}
          </div>
        )}

        <div className="estado-formulario-container">
          <div className="campo-grupo">
            <label className="campo-label">N° de ticket :</label>
            <div className="campo-input-grupo">

              {/* Dropdown con tickets del usuario */}
              {loading ? (
                <select className="campo-select" disabled>
                  <option>Cargando tickets...</option>
                </select>
              ) : (
                <select 
                  className="campo-select"
                  value={ticketSeleccionado}
                  onChange={(e) => setTicketSeleccionado(e.target.value)}
                >
                  <option value="">Seleccione un ticket</option>
                  {tickets.length === 0 ? (
                    <option disabled>No tienes tickets registrados</option>
                  ) : (
                    tickets.map((item, index) => (
                      <option key={index} value={item.ticket}>
                        {item.ticket} — {item.nombre_publicacion}
                      </option>
                    ))
                  )}
                </select>
              )}

              <button 
                className="btn-buscar" 
                onClick={buscarPublicacion}
                disabled={loading}
              >
                BUSCAR
              </button>
            </div>
          </div>

          <div className="campo-grupo">
            <label className="campo-label">Fecha de ingreso :</label>
            <input 
              type="text" 
              className="campo-input" 
              value={datosPublicacion.fechaIngreso} 
              readOnly 
            />
          </div>

          <div className="campo-grupo">
            <label className="campo-label">Fecha de resolucion :</label>
            <input 
              type="text" 
              className="campo-input" 
              value={datosPublicacion.fechaResolucion} 
              readOnly 
            />
          </div>

          <div className="campo-grupo">
            <label className="campo-label">Estado :</label>
            <div style={{
              padding: '8px 12px',
              border: '2px solid #000',
              maxWidth: '400px',
              width: '100%',
              backgroundColor: datosPublicacion.estado === 'Pendiente' ? '#FFA500'
                            : datosPublicacion.estado === 'Aprobada'  ? '#008000'
                            : datosPublicacion.estado === 'Rechazada' ? '#FF0000'
                            : '#ffffff',
              color: datosPublicacion.estado ? '#ffffff' : '#000000',
              fontFamily: "'Arial Black', Arial, sans-serif",
              fontSize: '16px',
              fontWeight: '900',
              minHeight: '38px',
              display: 'flex',
              alignItems: 'center'
            }}>
              {datosPublicacion.estado || ''}
            </div>
          </div>

          <div className="campo-grupo">
          <label className="campo-label">
              Dias - Horas restantes para finalizacion del proceso :
            </label>
            <input 
              type="text" 
              className="campo-input" 
              value={datosPublicacion.diasRestantes} 
              readOnly 
            />
          </div>
        </div>

        <div className="estado-informativo">
          <p className="texto-informativo">Informativo :</p>
        </div>
</div>
    </div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </>
  );
};

export default EstadoEdicion;